import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { withRouter } from 'react-router'
import { ROUTES } from '../../lib'
import IntroTutorialWakeScreen from './introTutorialWakeScreen'
import IntroTutorialVideoScreen from './introTutorialVideoScreen'
import { MainContainer } from './styled'
import {
  SCREEN_1,
  SCREEN_2,
  DEFAULT
} from './constants'

// Main cotainer holding the intro tutrial screens
class IntroTutorialContainer extends Component {
  state = { currentView: SCREEN_1 }

  setCurrentView = newView => {
    this.setState({ currentView: newView })
  }

  setVideoPlayingState = isPlaying => {
    this.setState({ isVideoPlaying: isPlaying })
  }

  render () {
    const { currentView, isVideoPlaying } = this.state
    return (
      <MainContainer isvideoplaying={isVideoPlaying ? 'true' : 'false'}>
        {(currentView === SCREEN_1) &&
          <IntroTutorialWakeScreen parentCallback={() => this.setCurrentView(SCREEN_2)} />}
        {(currentView === SCREEN_2) &&
          <IntroTutorialVideoScreen
            parentCallback={() => this.setCurrentView(DEFAULT)}
            videoStateCallback={this.setVideoPlayingState}
          />}
        {(currentView === DEFAULT) && <Redirect to={ROUTES.HOME} />}
      </MainContainer>
    )
  }
}

export default withRouter(IntroTutorialContainer)
